<template>
  <div
    class="nav-bar"
    :style="{
      height: navheight + Statusheight + 'px',
      'background-color': backgroudColor,
    }"
    v-if="navShow"
  >
    <div class="title" :style="{ 'background-color': backgroudColor }">
      <StatusBar :height="Statusheight" :bgColor="backgroudColor" />
      <div class="nav-box" :style="{ height: navheight + 'px' }">
        <div class="left" @click="Goback">
          <van-icon name="arrow-left" :color="titlecolor" size="22" />
          <slot name='close'/>
        </div>
        <div class="nav_title" :style="{ color: titlecolor }">{{ title }}</div>
        <div class="right" @click="$emit('click-right')">
          {{ righttext }}
          <slot name="right"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { goBack } from "@/plugins/webview";
import { NavBarHeight } from "@/const/common";
export default {
  props: {
    backType: {
      default: "h5",
    },
    title: {
      type: String,
      default: "首页",
    },
    isblack: {
      type: Boolean,
      default: false,
    },
    titlecolor: {
      default: "#000",
    },
    backgroudColor: {
      default: "#fff",
    },
    righttext: {
      default: "",
    },
  },
  data() {
    return {
      navheight: NavBarHeight,
      navShow: true,
    };
  },
  computed: {
    Statusheight() {
      return store.getters.GetStatus;
    },
  },
  mounted() {
    this.navShow = this.$route.query.navShow==0 ? false : true;
  },
  methods: {
    Goback() {
      this.$emit("click-left");
      if (this.backType != "app") {
        this.$router.go(-1);
      } else {
        goBack();
      }
    },
    blackclick() {
      this.$emit("blackclick");
    },
    searchclick() {
      console.log("搜索");
    },
  },
};
</script>

<style scoped>
.nav-bar {
  position: relative;
  width: 100%;
}
.title {
  background-color: rgb(59, 161, 245);
  color: white;
  /* line-height: 40px; */
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 9999;
  font-weight: 650;
}
.nav-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.left {
  position: absolute;
  /* top: 50%; */
  left: 15px;
}
.nav_title {
  /* flex: 1; */
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}
.right {
  position: absolute;
  right: 15px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.img {
  width: 25px;
  height: 25px;
}
</style>